/** Takı ürünleri — ürün tipi / ayar seçenekleri (yeni ürün + ürün detayı ile ortak). */
export const TAKI_URUN_TIPLERI = [
  '22 Ayar Bilezik',
  '14 Ayar Bilezik',
  '8 Ayar Bilezik',
  '22 Ayar Takı',
  '21 Ayar Takı',
  '18 Ayar Takı',
  '14 Ayar Takı',
  '8 Ayar Takı'
];
